import { Http } from 'angular2/http';
import { Injectable } from 'angular2/core';

@Injectable()
export class StudyGuideService {
  guides;

  constructor(public http: Http) {
    this.guides = [];
    this.retrieveGuides();
  }

  retrieveGuides() {
    if(this.guides.length == 0) {
      // this.http.get('mock.json')
      //this.http.get('file:///android_asset/www/mock.json')
      this.http.get('https://www.ocgracefirst.com/wp-json/llch/v2/study_guide/all')
          .subscribe(data => {
            var guides = data.json();
            var guide;
            while(guide = guides.shift()){
              this.guides.push(guide);
            }
          });
    }
  }

  getGuides() {
    return this.guides;
  }

  getGuide() {
    
  }
}